import * as React from 'react';
import { Loading } from '../../Loading';
import { ContainerErrorDialogProps } from './ContainerErrorDialog';

const ContainerErrorDialog = React.lazy(() =>
  import(/* webpackChunkName: "containerErrorDialog", webpackPrefetch: true */ './ContainerErrorDialog').then((m) => ({
    default: m.ContainerErrorDialog
  }))
);

/**
 * Lazy load container error dialog
 * @param props ContainerErrorDialogProps
 */
export function getContainerErrorDialog(props: ContainerErrorDialogProps) {
  return (
    <React.Suspense fallback={<Loading />}>
      <ContainerErrorDialog {...props} />
    </React.Suspense>
  );
}
